import { useEffect, useState } from "react"
import { getDeviceInfo } from "lib/video"

export default function useDevices() {
  const [devices, setDevice] = useState<MediaDeviceInfo[]>([])

  useEffect(() => {
    const getDevices = () =>
      getDeviceInfo().then((devices) => setDevice(devices))
    navigator.mediaDevices.addEventListener("devicechange", getDevices)

    getDevices()

    return () => {
      navigator.mediaDevices.removeEventListener("devicechange", getDevices)
    }
  }, [])

  return devices
}
